import React, { useState, useEffect, useRef } from 'react';
import HighFidelityYieldChart from './HighFidelityYieldChart';
import apiClient from '../../services/apiClient';
import { fetchYieldPayload } from '../../utils/yieldApiUtils';

const AAAYieldChartRedesign = ({ showTrades = true, highlightYear, maxYear }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [apiData, setApiData] = useState([]);
  const [topTrades, setTopTrades] = useState([]);
  const chartRef = useRef(null);

  const fetchYieldData = async () => {
    try {
      setIsLoading(true);
      setError(null);
      const baseUrl = process.env.REACT_APP_BASE_URL;
      const queryParams = new URLSearchParams({
        rating: 'AAA',
        issuerType: 'psu',
        securityType: 'secured'
      });
      const apiUrl = `${baseUrl}/yield/bonds?${queryParams.toString()}`;
      const payload = await fetchYieldPayload(apiClient, apiUrl);

      if (payload?.yieldData) {
        setApiData(payload.yieldData);
        setTopTrades(payload.topBondsTradeValues || []);
      } else {
        throw new Error('Invalid API response format');
      }
    } catch (err) {
      console.error('Error fetching AAA yield data:', err);
      setError(err.message || 'Failed to fetch AAA yield data');
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (isVisible) {
      fetchYieldData();
    }
  }, [isVisible]);

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) setIsVisible(true);
    }, { threshold: 0.1 });
    if (chartRef.current) observer.observe(chartRef.current);
    return () => chartRef.current && observer.unobserve(chartRef.current);
  }, []);

  return (
    <div ref={chartRef} className={`aaa-yield-curve-section ${isVisible ? 'visible' : ''}`}>
      <HighFidelityYieldChart 
        title={highlightYear != null ? 'AAA PSU Secured Yield Curve' : 'AAA PSU Secured Yield Curve'}
        type="Corporate"
        apiData={apiData}
        isLoading={isLoading}
        error={error}
        topTrades={showTrades ? topTrades : []}
        tradeDate={topTrades?.[0]?.tradeDate}
        maxYear={maxYear}
      />
    </div>
  );
};

export default AAAYieldChartRedesign;
